import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../../common/axios";
import { AxiosResponse } from "axios";
import { PartnerRegionalMultiplierListType } from "../../../slices/partner-program/regional-multipliers/Types";
import { partnerRegionalMultiplierSliceAction } from "../../../slices/partner-program/regional-multipliers";
import { AddPartnerRegionalMultiplierDetailsType, getPartnerRegionalMultiplierListSagaAction, partnerRegionalMultiplierSagaActionTypes, updatePartnerRegionalMultiplierDetailsType } from "./saga-actions";


type getPartnerRegionalMultiplierDeatilsListAPIResponseType = {
    success: boolean;
    message: string;
    data: PartnerRegionalMultiplierListType;
};
const getAllPartnersRegionalMultiplierListAPI = async () => {
    let response = axiosRestInstance
        .get<AxiosResponse<getPartnerRegionalMultiplierDeatilsListAPIResponseType>>(
            "/partner-program/regionalModifiers/getData"
        )
        .then((res) => res.data);
    return response;
};

type addPartnerRegionalMultiplierAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};
const insertPartnerregionalModifiersListAPI = async (partnerDetails: AddPartnerRegionalMultiplierDetailsType) => {
  let response = axiosRestInstance
    .post<AxiosResponse<addPartnerRegionalMultiplierAPIResponseType>>(
      "/partner-program/regionalModifiers/insert",
      partnerDetails
    )
    .then((res) => res.data);
  return response;
};

type updatePartnersRegionalMultiplieristAPIResponseType = {
  success: boolean;
  message: string;
  data: any;
};
const updatePartnerRegionalMultiplierListAPI = async (partnerRegionalMultiplier: updatePartnerRegionalMultiplierDetailsType) => {
  let response = axiosRestInstance
    .put<AxiosResponse<updatePartnersRegionalMultiplieristAPIResponseType>>(
        "/partner-program/regionalModifiers/update/" + partnerRegionalMultiplier.ID,
        partnerRegionalMultiplier
    )
    .then((res: { data: any; }) => res.data);
  return response;
};

type deletePartnersRegionalMultiplieristAPIResponseType = {
  success: boolean;
  message: string;   
  data: any;
};
const deletePartnerRegionalMultiplierAPI = async (partnerRegionalMultiplierID: number) => {
  let response = axiosRestInstance
    .delete<AxiosResponse<deletePartnersRegionalMultiplieristAPIResponseType>>("/partner-program/regionalModifiers/" + partnerRegionalMultiplierID)
    .then((res) => res.data);
  return response;
};

// ----------------------- API Above

function* getAllPartnersRegionalMultiplierListSaga(action: {
    type: string;
    payload: {
        ID: number;
    };
}) {
    try {
        yield put(partnerRegionalMultiplierSliceAction.setPartnerRegionalListLoading(true));
        let response: getPartnerRegionalMultiplierDeatilsListAPIResponseType = yield call(
            getAllPartnersRegionalMultiplierListAPI
        );
        const list = response.data ? response.data.reverse() : [];
        yield put(partnerRegionalMultiplierSliceAction.setPartnerRegionalMultiplierList(list));
        yield put(partnerRegionalMultiplierSliceAction.setPartnerRegionalListLoading(false));
        yield put(partnerRegionalMultiplierSliceAction.setFetchedPartnerRegionalMultiplierID(action.payload.ID));
    } catch (e) {
        yield put(partnerRegionalMultiplierSliceAction.setPartnerRegionalMultiplierList([]));
        yield put(partnerRegionalMultiplierSliceAction.setPartnerRegionalListLoading(false));
        console.log(e);
    }
}

function* addPartnerRegionalMultiplierListSaga(action: { type: string; payload: AddPartnerRegionalMultiplierDetailsType }) {
  try {
    yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListLoading(true));
    let response: addPartnerRegionalMultiplierAPIResponseType = yield call(
      insertPartnerregionalModifiersListAPI,
      action.payload
    );
    yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListLoading(false));
    yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListMessage(''));
     yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListStatus(true));
    if (action.payload.ID)
      yield put(getPartnerRegionalMultiplierListSagaAction(action.payload.ID));
    else yield put(getPartnerRegionalMultiplierListSagaAction(action.payload.ID));
  } catch (e: any) {
    yield put(
      partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListMessage(
        e.response?.data?.message || "Something went wrong!"
      )
    );
    yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListLoading(false));
    yield put(partnerRegionalMultiplierSliceAction.setAddpartnerRegionalListStatus(false));
    console.log(e);
  }
}

function* updatePartnerRegionalMultiplierListSaga(action: {
  type: string;
  payload: { partnerRegionalMultiplier: updatePartnerRegionalMultiplierDetailsType };
}) {
  try {
    yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListLoading(true));
    yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListMessage(""));

    const resp: { success: boolean; message: string; data: any } = yield call(
      updatePartnerRegionalMultiplierListAPI,
      action.payload.partnerRegionalMultiplier
    );

    if (resp?.success) {
      yield put(partnerRegionalMultiplierSliceAction.setupdatepartnerRegionalListStatus(true));
      yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListMessage(resp.message ?? "Updated"));
      yield put(
        partnerRegionalMultiplierSliceAction.setUpdatePartnerRegionalMultiplierListUpdate(action.payload.partnerRegionalMultiplier)
      );
    } else {
      yield put(partnerRegionalMultiplierSliceAction.setupdatepartnerRegionalListStatus(false));
      yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListMessage(resp?.message ?? "Update failed"));
    }
  } catch (e: any) {
    yield put(partnerRegionalMultiplierSliceAction.setupdatepartnerRegionalListStatus(false));
    yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListMessage(e?.message ?? "Unexpected error"));
  } finally {
    yield put(partnerRegionalMultiplierSliceAction.setUpdatepartnerRegionalListLoading(false));
  }
}

function* deletePartnerRegionalMultiplierListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(partnerRegionalMultiplierSliceAction.setDeletePartnerRegionalMultiplierLoading(true));
    let response: deletePartnersRegionalMultiplieristAPIResponseType = yield call(
      deletePartnerRegionalMultiplierAPI,
      action.payload.ID
    );
    yield put(partnerRegionalMultiplierSliceAction.setDeletePartnerRegionalMultiplierStatus(true));
    if(response.success){
       yield put(getPartnerRegionalMultiplierListSagaAction(action.payload.ID));
    }
  } catch (e: any) {
    yield put(partnerRegionalMultiplierSliceAction.setDeletePartnerRegionalMultiplierStatus(false));
    yield put(
      partnerRegionalMultiplierSliceAction.setDeletePartnerRegionalMultiplierMessage(
        e?.response?.data?.message || "Something went wrong"
      )
    );
    console.log(e);
  } finally {
    yield put(partnerRegionalMultiplierSliceAction.setDeletePartnerRegionalMultiplierLoading(false));
  }
}


function* partnerRegionalMultiplierListSaga() {
    yield takeLatest(partnerRegionalMultiplierSagaActionTypes.callPartnerRegionalMultiplierListSaga, getAllPartnersRegionalMultiplierListSaga);
    yield takeLatest(partnerRegionalMultiplierSagaActionTypes.callAddPartnerRegionalMultiplierSaga, addPartnerRegionalMultiplierListSaga);
    yield takeLatest(partnerRegionalMultiplierSagaActionTypes.callUpdatePartnerRegionalMultiplierSaga, updatePartnerRegionalMultiplierListSaga);
    yield takeLatest(partnerRegionalMultiplierSagaActionTypes.callDeletePartnerRegionalMultiplierSaga, deletePartnerRegionalMultiplierListSaga);
}

export default partnerRegionalMultiplierListSaga;